// extracted by mini-css-extract-plugin
module.exports = {"CheckMarkIcon":"CheckMarkIcon_CheckMarkIcon__1M6wT","checkbox":"CheckMarkIcon_checkbox__r9wq1"};